import { StakeMap } from './stakeAction';

const InitState = {
    isLoading: false,
    increasePrice: '1',
    // increasePrice: '0',
    notaryCharge: '0',
    goldDeliveryCharge: '0',
    backdrop: true,
    currentSlots: [],
    ordersList: [],
    orderBatch: 0,
    orderLimit: 10,
    WithdrawBatch: 0,
    WithdrawLimit: 10,
    refreshOrders: true,
    puchaseGoldID: {
        records: [],
        totalRecords: 0,
    },
    refreshPurchaseGold: true,
    withdrawSlots: {
        slots: [],
        totalBalance: 0,
        withdrawList: [],
        totalRecords: 0,
    },
    transactionDetails: {},
    withdrawSettings: {
        fixedCharge: "",
        chargeType: "PERCENTAGE",
        currencyMethod: "USD",
        paybackDay: "7"
    }
    // refreshMint: true
}

export const stakeReducer = (state = InitState, action) => {
    switch (action.type) {
        case StakeMap.GET_CURRENT_SLOT_START: 
        case StakeMap.GET_USER_PURCHASE_HISTORY_START:
        case StakeMap.GET_ALL_PURCHASE_GOLD_ORDER_BYID_START: {
            return {
                ...state,
                backdrop: true,
            }
        }

        case StakeMap.GET_CURRENT_SLOT_SUCCESS: {
            return {
                ...state,
                backdrop: false,
                currentSlots: action.payload
            }
        }

        case StakeMap.GET_CURRENT_SLOT_ERROR: {
            return {
                ...state,
                backdrop: false,
                refreshOrders: false
            }
        }

        case StakeMap.GET_GRAM_PRICE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                backdrop: false,
                increasePrice: parseFloat(action.payload.increasePrice),
                goldDeliveryCharge: action.payload.goldDeliveryCharge,
                notaryCharge: action.payload.notaryCharge
            }
        }

        case StakeMap.SET_WITHDRAW_REQUEST_START:
        case StakeMap.PURCHASE_GOLD_START: {
            return {
                ...state,
                backdrop: false,
                isLoading: true,
            }
        }

        case StakeMap.PURCHASE_GOLD_SUCCESS: {
            return {
                ...state,
                backdrop: false,
                isLoading: false,
                transactionDetails: action.payload
            }
        }

        case StakeMap.SET_WITHDRAW_REQUEST_SUCCESS:
        case StakeMap.SET_WITHDRAW_REQUEST_ERROR:
        case StakeMap.PURCHASE_GOLD_ERROR: {
            return {
                ...state,
                backdrop: false,
                isLoading: false,
            }
        }
        case StakeMap.GET_ALL_PURCHASE_GOLD_ORDER_BYID_SUCCESS: {
            return {
                ...state,
                backdrop: false,
                puchaseGoldID: action.payload,
                refreshPurchaseGold: false,
            }
        }

        case StakeMap.GET_USER_PURCHASE_HISTORY_SUCCESS: {
            return {
                ...state,
                backdrop: false,
                withdrawSlots: action.payload
            }
        }

        case StakeMap.GET_USER_PURCHASE_HISTORY_ERROR:
        case StakeMap.GET_ALL_PURCHASE_GOLD_ORDER_BYID_ERROR: {
            return {
                ...state,
                backdrop: false,
                refreshPurchaseGold: false,
            }
        }

        case StakeMap.SET_ORDER_BATCH_NUMBER: {
            return {
                ...state,
                orderBatch: action.payload,
                refreshPurchaseGold: true,
            }
        }

        case StakeMap.SET_WITHDRAW_BATCH_NUMBER: {
            return {
                ...state,
                WithdrawBatch: action.payload,
                refreshPurchaseGold: true,
            }
        }

        case StakeMap.RESET_TRANSACTION_DETAILS_DATA: {
            return {
                ...state,
                transactionDetails: {}
            }
        }

        case StakeMap.GET_WITHDRAW_SETTINGS_SUCCESS: {
            return {
                ...state,
                backdrop: false,
                withdrawSettings: {
                    ...state.withdrawSettings,
                    ...action.payload
                }
            }
        }

        default:
            return {
                ...state,
                backdrop: false
            }
    }
}

export default stakeReducer;